import { render } from "./DataMetrics.vue?vue&type=template&id=b196aa40"
import script from "./DataMetrics.vue?vue&type=script&lang=js"
export * from "./DataMetrics.vue?vue&type=script&lang=js"

import "./DataMetrics.vue?vue&type=style&index=0&id=b196aa40&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__